import { useRef, useState } from "react"
import { useLocation } from "react-router-dom"
import { SectionHeading, TableCustom, WrapperAdvancedSearch, FooterButtonVolver } from "../../components/common"
import { getDateToString } from "../../utils/convert"
import { ALERT_TYPE, OPERATION_MODE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { useLista, useManagedContext, usePermissions } from "../../components/hooks"
import { useSearchParams } from "react-router-dom"
import { ServerRequest } from "../../utils/apiweb"
import { APIS } from "../../config/apis"
import { onRequestError, onRequestNoSuccess } from "../../utils/requests"
import TipoRecargoDescuentoModal from "../../components/controls/TipoRecargoDescuentoModal"
import { PERMISSIONS } from "../../consts/permissions"
const TipoRecargoDescuentosView = () => {
    const { setIsLoading, showMessageModal } = useManagedContext()
    const location = useLocation()
    const previousFilters = location.state?.filters

    const [tipos, setTipos] = useState([])
    const [editItem, setEditItem] = useState()
    const [editMode, setEditMode] = useState()
    const [tableVisible, setTableVisible] = useState(false)

    const searchRef = useRef()

    const { hasPermission } = usePermissions();
    const [searchParams] = useSearchParams();
    const canEdit = hasPermission(PERMISSIONS.LISTAS_INGRESOS_PUBLICOS_EDIT);
    const isViewOnly = searchParams.get('mode') === OPERATION_MODE.VIEW;
    const allowEditActions = canEdit && !isViewOnly;

    const [_, getRowLista ] = useLista({
        listas: ['TipoTributo'],
        onLoaded: (_, isSuccess, error) => {
          if (!isSuccess) ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error)
        },
        memo: {
          key: 'TipoTributo',
          timeout: 0
        }
    })

    const filterData = data => {
        const { codigo, nombre, idTipoTributo } = searchRef.current.filters

        let filtered = [...data]

        if (codigo !== '') filtered = filtered.filter(item => item.codigo.toLowerCase().includes(codigo.toLowerCase()))
        if (nombre !== '') filtered = filtered.filter(item => item.nombre.toLowerCase().includes(nombre.toLowerCase()))
        if (idTipoTributo !== 0) filtered = filtered.filter(item => item.idTipoTributo === idTipoTributo)

        return filtered
    }

    const Search = () => {
        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.TIPO_RECARGO_DESCUENTO,
            null,
            null,
            res => res.json().then(data => {
                setTipos(filterData(data))
                setIsLoading(false)
                setTableVisible(true)
                setEditMode(null)
                setEditItem(null)
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
                setEditMode(null)
                setEditItem(null)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
                setEditMode(null)
                setEditItem(null)
            },
        )
    }

    const confirmRemoveId = (id) => {
        setIsLoading(true)
        ServerRequest(
            REQUEST_METHOD.DELETE,
            null,
            true,
            APIS.URLS.TIPO_RECARGO_DESCUENTO,
            `/${id}`,
            null,
            () => {
                Search()
                setIsLoading(false)
            },
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
    }

    const onModalCancel = () => {
        setEditItem(null)
        setEditMode(null)
    }

    const onModalConfirm = () => {
        setEditItem(null)
        setEditMode(null)
        if (tableVisible) Search()
    }

    const avmr = {
        onAdd: () => {
            setEditMode('add')
            setEditItem({
                id: -Date.now(),
                codigo: '',
                nombre: '',
                orden: '',
                tipo: '',
                idTipoTributo: 0,
                porcentaje: 0,
                importe: 0,
                emiteSolicitud: false,
                requireOtorgamiento: false,
                fechaDesde: null,
                fechaHasta: null,
                procedimiento: '',
            })
        },
        onView: (item) => {
            setEditMode('view')
            setEditItem(item)
        },
        onModify: (item) => {
            setEditMode('modify')
            setEditItem(item)
        },
        onRemove: ({ id }) => {
            showMessageModal({
                title: "Confirmación",
                message: "¿Está seguro de borrar el registro?",
                onConfirm: () => confirmRemoveId(id),
            })
        }
    }

    return <>
        <SectionHeading titles={[{ title: 'Entidades' }, { title: 'Administración de listas', url: '/entidades' }, { title: 'Recargos y descuentos' }]} 
                       onAddClick={allowEditActions ? avmr.onAdd : null} {...{tableVisible}} />

        <section className="section-accordion">
            <WrapperAdvancedSearch
                ref={searchRef}
                filters={[
                    { title: 'Código', field: 'codigo', type: 'string', size: 2, searchOnEnter: true, },
                    { title: 'Nombre', field: 'nombre', type: 'string', size: 4, searchOnEnter: true, },
                    { title: 'Tipo de tributo', field: 'idTipoTributo', type: 'list', lista: 'TipoTributo', textItemZero: 'Todos los tributos', size: 2 },
                ]}
                onSearch={Search}
            />

            {tableVisible && (
                <TableCustom
                    className={'TableCustomBase m-top-20'}
                    data={tipos}
                    avmr={avmr}
                    messageEmpty="No se encontraron resultados"
                    columns={[
                        { Header: 'Código', accessor: 'codigo', width: '20%', },
                        { Header: 'Nombre', accessor: 'nombre', width: '20%', },
                        { Header: 'Tipo de tributo', accessor: 'idTipoTributo', width: '20%', Cell: ({ value }) =>  getRowLista('TipoTributo', value)?.nombre ?? '' },
                        { Header: 'Fecha desde', Cell: (data) => getDateToString(data.value, false), accessor: 'fechaDesde', width: '20%' },      
                        { Header: 'Fecha hasta', Cell: (data) => getDateToString(data.value, false), accessor: 'fechaHasta', width: '20%' },
                    ]}
                    editCode={PERMISSIONS.LISTAS_INGRESOS_PUBLICOS_EDIT}
                    disabled={!allowEditActions}
                />
            )}

            {editItem && (
                <TipoRecargoDescuentoModal
                    {...{ editItem, editMode }}
                    onCancel={onModalCancel}
                    onConfirm={onModalConfirm}
                />
            )}
        </section>
        <footer className='footer footer-action'>
            <div className='footer-action-container'>
                <FooterButtonVolver filters={previousFilters} to="/entidades" />
            </div>
        </footer>
    </>
}

export default TipoRecargoDescuentosView
